import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/TermsAndConditions.css";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <div>
      <nav className="navbar">
        <div className="navbar-logo">Privacy Notice</div>
        <button className="login-button" onClick={() => navigate("/login")}>
          Login
        </button>
      </nav>

      <div className="terms-container">
        <p className="meta">
          <strong>Effective Date:</strong> 23 July 2025
          <br />
          <strong>Last Updated:</strong> 23 July 2025
        </p>

        <section className="box">
          <h2>1. What personal information do we collect about you?</h2>
          <p>
            Personal information (also commonly known as personally identifiable
            information (PII) or personal data) is information that can be used
            to identify you, or any other individual to whom the information may
            relate. The personal information that we collect directly from those
            registering for the Service, includes the following categories:
          </p>
          <ul>
            <li>
              Personally, identifiable information (e.g. First Name, Last Name,
              Gender, DOB, Phone number; Email, zip/postal code);
            </li>
            <li>
              Personal profiles (Socio economic status, financial, insurance,
              sports, automotive, employment, education, health, home & family,
              lifestyles, ecommerce, media, technology & travel)
            </li>
            <li>Results of surveys taken;</li>
            <li>Survey history;</li>
            <li>An assigned unique identification number (“UID”)</li>
            <li>
              Non-personally identifiable information on your household members;
            </li>
            <li>
              Photo and video images of you as described in the next section;
            </li>
            <li>
              Company/employer and other relevant employment related
              information;
            </li>
            <li>Geographic or location information;</li>
            <li>
              Information contained in posts you may on the public forums and
              interactive features of the Service;
            </li>
            <li>
              Telephone calls and e-mails to us may be recorded and monitored
              for quality control purposes only, and we may also intercept
              communications made to individual members of staff at Op4Insights when this is required for business purposes and permitted
              by law;
            </li>
            <li>
              Where permitted by law, aggregated behavioral activity from your
              mobile device app, collected using a third-party meter.
            </li>
            <li>
              Other information that may be exchanged in the course of engaging
              with the Service. You will be aware of any subsequently collected
              information.
            </li>
          </ul>
        </section>

        <section className="box">
          <h2>2. Will Op4Insights Collect Photos or Videos of me?</h2>
          <p>
            Certain surveys will ask you to record photos or video of yourself
            as a part of the responses. You will be alerted to such collection
            before taking a survey. By choosing to take those surveys, and
            granting the appropriate rights at the time of taking the survey you
            will grant Op4Insights permission to use your likeness in a
            photograph, video, or other digital media (“photo”) in any and all
            of its publications, including web-based publications, without
            payment or other consideration. You understand and agree that all
            photos will become the property of Op4Insights and will not be
            returned. By taking such surveys you authorize Op4Insights to
            edit, alter, copy, exhibit, publish, or distribute these photos for
            any lawful purpose, including, but not limited to
            marketing/marketing researches purposes. In addition, you waive any
            right to inspect or approve the finished product where your likeness
            appears. Additionally, you waive any right to royalties or other
            compensation arising or related to the use of the photo. Depending
            on the jurisdiction in which you are located, you may have the
            option of expressing privacy rights as described in this Notice.
          </p>
        </section>

        <section className="box">
          <h2>3. How does Op4Insights use personal information?</h2>
          <p>
            Subject to the terms of this Privacy Notice, Op4Insights uses
            the above described categories of personal information in several
            ways. Unless otherwise stated specifically, the above information
            may be used for any of the following purposes:
          </p>
          <ul>
            <li>
              To administer the Service to you and its customers, including
              creating a database of individuals willing to take part in
              research and surveys and providing you information about rewards
              or gifts earned;
            </li>
            <li>To invite you to take part in surveys or research;</li>
            <li>
              To send you newsletters, e-mails relating to participation in any
              of our events, our proprietary product-related information,
              promotional events and content
            </li>
            <li>Incentivizing your participation in surveys;</li>
            <li>processing survey results;</li>
            <li>
              evaluating which individuals may be best suited for specific
              surveys based on past survey history;
            </li>
            <li>To respond to your requests;</li>
            <li>
              To distribute communications relevant to your use of the Service
              or surveys, such as system updates or information about your use
              of the Service or surveys;
            </li>
            <li>
              As may be necessary to support the operation of the Service, such
              as for billing, account maintenance, and record-keeping purposes;
            </li>
            <li>To maintain statutory and regulatory compliance;</li>
            <li>
              To send to you Op4Insights solicitations, product
              announcements, and the like that we feel may be of interest to you
              (you may “opt out” of receiving these marketing materials)
            </li>
            <li>
              In other manners after subsequent notice is provided to you and/or
              your consent is obtained, if necessary.
            </li>
          </ul>
          <p>
            Op4Insights will not sell or rent your personal information to
            third parties without your consent and such consent would be
            explicitly taken from you only after providing the clear reasoning
            behind sharing such information in an understandable manner.
          </p>
        </section>

        <section className="box">
          <h2>
            4. How do we share your Personal Information with third parties?
          </h2>
          <p>
            We may provide any of the described categories of personal
            information to Op4Insights (for Op4Insights) employees,
            consultants, affiliates or other businesses or persons for the
            purpose of processing such information on our behalf in order to
            provide the Service to you. We may share your Personal Information
            with third-party suppliers for the purpose of enhancement of our
            services. In such circumstances, we require that these parties agree
            to protect the confidentiality of such information consistent with
            the terms of this Privacy Notice. Certain functions of the platform
            may be provided by external service providers, such as, recruiting a
            professional data processing service institution to provide
            technical support in respect of data analysis to our platform.
          </p>
          <p>
            For this purpose, we will enter into an agreement with any entity
            (company, organization or individual) whom we would entrust
            processing of personal information. This will be implemented to
            agree upon the purpose, term and processing method of the entrusted
            processing, and detailing the type of personal information,
            protection measures as well as the rights and obligations of both
            parties. We would also carry out supervision of the personal
            information processing activities by the entrusted entity. 
            Op4Insights may also share your personal information with third party
            sample/market research companies (individually each a “Third-Party
            MR Company” and collectively the “Third-Party MR Companies”) for the
            purpose of identifying survey opportunities that you may be eligible
            for through those Third-Party MR Companies. If you are eligible for
            a survey opportunity, the Third-Party MR Company will provide your
            unique identification number and a survey link to us and we will
            invite you to participate in the survey. We will not share your
            name, email address, or phone number with the Third-Party MR
            Companies. If you have any questions about this data sharing or want
            to opt-out of the data sharing, please contact us as described
            hereunder in the last section titled as ‘Contact Us’.
          </p>
          <p>
            We will not share your personal information with other, third-party
            companies for their commercial or marketing use without your consent
            or except as part of a specific program or feature for which you
            have the ability to opt-in or opt-out.
          </p>
          <p>
            In addition, we may release personal information: (i) to the extent
            we have a good-faith belief that such action is necessary to comply
            with any applicable law; (ii) to enforce any provision of the Terms
            of Service, protect ourselves against any liability, defend
            ourselves against any claims, protect the rights, property and
            personal safety of any user, or protect the public welfare; (iii)
            when disclosure is required to maintain the security and integrity
            of the Service, or to protect any user’s security or the security of
            other persons, consistent with applicable laws (iv) to respond to a
            court order, subpoena, search warrant, or other legal process, to
            the extent permitted and as restricted by law; or (v) in the event
            that we go through a business transition, such as a merger,
            divestiture, acquisition, liquidation or sale of all or a portion of
            our assets.
          </p>
        </section>

        <section className="box">
          <h2>5. Retention of Data</h2>
          <p>
            Op4Insights will retain your personal information only for as
            long as is necessary for the purposes set out in this Notice,
            typically until your account is deleted. We will retain and use
            personal information to the extent necessary to comply with our
            legal obligations (for example, if we are required to retain your
            data to comply with applicable laws), resolve disputes and enforce
            our legal agreements and policies. Op4Insights will also
            retain usage data for internal analysis purposes. Usage data is
            generally retained for a shorter period of time, except when this
            data is used to strengthen the security or to improve the
            functionality of our Sites and/or Portals, or we are legally
            obligated to retain this data for longer periods. Op4Insights
            shall retain the captured data of panelists who have not completed
            the registration process while signing up on Op4Insights and/
            or have been identified as Fraudulent users by the Company. This is
            to ensure adequate support being provided to all those who could not
            complete the registration and to prevent misuse of Op4Insights
            surveys and incentive redemption process. You may request for
            deletion or erasure of your data in the email ID mentioned in “Data
            Privacy Rights (EU, Brazil, South Africa, and similar
            jurisdictions)” herein below. For the purposes of the above clause,
            “Fraudulent users” shall mean and include respondents that resort to
            unlawful means (creating bots, creating multiple accounts etc.) of
            answering surveys multiple times to gain extra rewards or
            respondents who speed through the survey without paying attention to
            questions or answers options or respondents who provide incorrect
            information in the survey when compared with their profiling
            information and similar users.
          </p>
        </section>

        <section className="box">
          <h2>6. Cookies, Device Data, and How it is Used</h2>
          <p>
            When you use our Service, we may record unique identifiers
            associated with your device (such as the device ID and IP address),
            your activity within the Service, and your network location. The
            Op4Insights uses aggregated information (such as anonymous user
            usage information, cookies, IP addresses, browser type, clickstream
            information, etc.) to improve the quality and design of the Service
            and to create new features, promotions, functionality, and services
            by storing, tracking, and analysing user preferences and trends.
            Specifically, we may automatically collect the following information
            about your use of Service through cookies and other technologies:
          </p>
          <ul>
            <li>Domain name</li>
            <li>Browser type and operating system</li>
            <li>Web pages you view</li>
            <li>Links you click</li>
            <li>IP address</li>
            <li>
              the length of time you visit the Sites, Portals, and/or Services
            </li>
            <li>the referring URL or the webpage that led you to the Sites</li>
          </ul>
          <p>
            We may also collect information regarding application-level events,
            such as crashes, and associate that temporarily with your account to
            provide customer service. In some circumstances, we may combine this
            information with personal information collected from you (and
            third-party service providers may do so on behalf of us). In
            addition, we may use "cookies," clear gifs, and log file information
            that help us determine the type of content and pages to which you
            link, the length of time you spend at any particular area of the
            Service, and the portion of the Service you choose to use. A cookie
            is a small text file that is sent by a website to your computer or
            mobile device where it is stored by your web browser. A cookie
            contains limited information, usually a unique identifier and the
            name of the site. Your browser has options to accept, reject or
            provide you with notice when a cookie is sent. Our cookies can only
            be read by Op4Insights; they do not execute any code or virus;
            and they do not contain any personal information. Cookies allow The
            Op4Insights to serve you better and more efficiently, and to
            personalize your experience with the Service. We may use cookies for
            many purposes, including (without limitation) to save your password
            so you don’t have to re-enter it each time you visit the Service,
            and to deliver content (which may include third party
            advertisements) specific to your interests. We may use third party
            service providers to help us analyze certain online activities. For
            example, these service providers may help us measure the performance
            of our online campaigns or analyze visitor activity on the Service.
            We may permit these service providers to use cookies and other
            technologies to perform these services for Op4Insights. We do
            not share any personal information about our customers with these
            third-party service providers, and these service providers do not
            collect such information on our behalf. Our third-party service
            providers are required to comply fully with this Privacy Notice. You
            may also refer to our Cookies Policy here.
          </p>
        </section>

        <section className="box">
          <h2>7. Storage of Personal Information</h2>
          <p>
            Any Personal Information that you provide to us via 
            Op4Insights Service, is securely transferred and stored on our servers
            situated in India and the United States of America. Additionally,
            based upon the jurisdictional requirement of the survey, we may also
            store your information on a server situated in other such relevant
            country, ensuring proper data security measures. We may transfer
            this information to third-parties in different jurisdictions
            allowing processing for the purpose of enhancement of our services.
          </p>
        </section>

        <section className="box">
          <h2>8. International Data Transfer</h2>
          <p>
            If you are located outside the United States, in particular if you
            are located in Argentina, Brazil, South Africa, Switzerland, the
            United Kingdom, or the European Economic Area (“EEA”), please note
            that we and our servers are located outside of the EEA. Any
            information that you provide to us may be transferred to and
            processed in Indian and other countries around the world where we do
            business. Although this may include recipients of information
            located in countries where there may be a lower level of legal
            protection for your personal information than in your country, we
            will protect your information in accordance with requirements
            applicable to the law in your particular jurisdiction and take steps
            to only share with third parties that offer similar protection. By
            using our Service, you unambiguously consent to your information
            being collected, processed, used, and transferred as disclosed
            herein.
          </p>
        </section>

        <section className="box">
          <h2>
            9. Data Privacy Rights (EU, Brazil, South Africa, and similar
            jurisdictions)
          </h2>
          <p>
            If you are located in a country with robust Data Privacy Laws, they
            grant you a bundle of rights for protecting your privacy. In
            particular, the right to access, correct, and delete the personal
            information we hold about you. Op4Insights will retain your
            personal information for the length of time you engage with our
            services as described in the retention section of this Notice, until
            you request deletion of such personal information. In certain
            circumstances, you have the following data protection rights:
          </p>
          <ul>
            <li>
              The right to access, update, or delete the personal information we
              have on you.
            </li>
            <li>
              The right of rectification. You have the right to have your
              personal information rectified if that information is inaccurate
              or incomplete.
            </li>
            <li>
              The right to object. You have the right to object to our
              processing of your personal information.
            </li>
            <li>
              The right of restriction. You have the right to request that we
              restrict the processing of your personal information.
            </li>
            <li>
              The right to data portability. You have the right to be provided
              with a copy of the personal information we have on you in a
              structured, machine-readable and commonly used format.
            </li>
            <li>
              The right to withdraw consent. You also have the right to withdraw
              your consent at any time where we relied on your consent to
              process your personal information.
            </li>
          </ul>
          <p>
            In order make a request regarding your personal information, please
            contact [ dataprotectionofficer@Op4Insights.com ]. If you
            have a comment, question, or complaint about how we are handling
            your personal information, we hope that you contact us at
            dataprotectionofficer@Op4Insights.com in order to allow us to
            resolve the matter. In addition, depending on where you are located,
            you may submit a complaint regarding the processing of your personal
            information to a regulator (e.g. the EU data protection
            authorities).
          </p>
        </section>

        <section className="box">
          <h2>10. Legal Basis for Processing under GDPR and similar laws</h2>
          <p>
            If you are located in the EEA, our legal basis for collecting and
            using the personal information described in this Notice depends on
            the personal information we collect and the specific context in
            which we collect it.
          </p>
          <ul>
            <li>We may process personal information because:</li>
            <li>We need to perform a contract with you;</li>
            <li>You have given us consent to do so;</li>
            <li>
              The processing is in our legitimate interest to offer the Service,
              when that legitimate interest is not overridden by your rights;
            </li>
            <li>To comply with the law.</li>
          </ul>
          <p>
            Where personal information is processed based on consent, EU
            residents have the right to withdraw such consent at any time. To do
            so, please contact us as described in this Notice. If there is a
            different legal basis that would permit us to continue processing
            your personal information after withdrawing consent, we will notify
            you of that legal basis at the time of your request.
          </p>
        </section>

        <section className="box">
          <h2>11. California Privacy Rights</h2>
          <p>
            If you are a California resident, California law may provide you
            with certain rights with regard to your personal information under
            the California Consumer Privacy Act (“CCPA”). Throughout this
            Privacy Notice you will find information required by CCPA regarding
            the categories of personal information collected from you; the
            purposes for which we use personal information, and the categories
            of third parties your data may be shared with. This information is
            current as of the date of the Notice and is applicable in the 12
            months preceding the effective date of the Notice. As a California
            resident, the CCPA provides you the ability to make inquiries
            regarding to your personal information. Specifically, the degree to
            which the information is not already provided in this Privacy
            Notice, you have the right to request disclosure about the
            collection and use of your personal information over the past 12
            months, including:
          </p>
          <ul>
            <li>The categories of personal information collected about you.</li>
            <li>
              The categories of sources for the personal information collected
              about you.
            </li>
            <li>
              The business or commercial purpose for collecting your personal
              information.
            </li>
            <li>
              The categories of third parties with whom your personal
              information was shared.
            </li>
            <li>
              The specific pieces of personal information collected about you.
            </li>
            <li>
              If your personal information was disclosed for a business purpose,
              the personal information categories disclosed and the categories
              of third parties to which the information was disclosed.
            </li>
            <li>
              If your personal information was sold in the past 12 months, the
              personal information categories sold and the categories of third
              parties to which the information was sold. (NOTE: Op4Insights DOES NOT SELL PERSONAL INFORMATION)
            </li>
          </ul>
          <p>
            Please note that you may only make the above requests twice in a
            12-month period. You also have the right to request that any of your
            personal information collected and retained be deleted, subject to
            certain exceptions. Finally, you have the right to not receive
            discriminatory treatment by Op4Insights or any business for
            exercising any of the rights provided under CCPA. You may submit a
            request to delete your personal data under CCPA by logging into your
            Op4Insights account, then clicking on “Unsubscribe” in the Account
            Settings and choosing “Unsubscribe & Delete" option OR by contacting
            us at: dataprotectionofficer@Op4Insights.com]. If we receive
            a CCPA request from you, we will first make a determination
            regarding the applicability of the law, and we will then take steps
            to verify your identity prior to responding. The steps to verify
            your identity may vary based on our relationship with you, but, at a
            minimum, it will take the form of confirming and matching the
            information submitted in the request with information already held
            by Op4Insights and/or contacting you through previously used
            channels to confirm that you submitted the request (i.e. confirming
            identity through contact information that we have on file, not the
            contact information submitted to make the request). Your rights as
            stated here can also be exercised by an authorized agent on your
            behalf. Op4Insights will follow the standards set by the
            Attorney General of California regarding designation of an
            authorized agent to exercise rights under CCPA. You may review
            information available through from the Attorney General regarding
            how an individual can be designated as an authorized agent under
            CCPA. In addition to CCPA, California Civil Code Section 1798.83
            permits users of the Website who are California residents to request
            certain information regarding its disclosure of personal information
            to third parties for their direct marketing purposes. To make such a
            request, please contact us as described here under section ‘Contact
            Us’.
          </p>
        </section>

        <section className="box">
          <h2>12. Information Storage and Security</h2>
          <p>
            Op4Insights is an ISO/IEC 27001:2013 and ISO/IEC 27701:2019
            certified company and we take adequate steps to help protect your
            personal information. We employ industry-standard security measures
            designed to protect the security of all information submitted
            through the Service. However, the security of information
            transmitted through the internet or via a mobile device can never be
            guaranteed. We are not responsible for any interception or
            interruption of any communications through the internet or for
            changes to or losses of data.
          </p>
          <p>
            Users of the Service are responsible for maintaining the security of
            any password, user ID or other form of authentication involved in
            obtaining access to password protected or secure areas of the
            Service. In order to protect you and your information, we may
            suspend your use of any of the Service, without notice, pending an
            investigation, if any breach of security is suspected.
          </p>
        </section>

        <section className="box">
          <h2>13. External Links</h2>
          <p>
            The Service may contain links to other websites maintained by third
            parties. Please be aware that we exercise no control over linked
            sites and Op4Insights is not responsible for the privacy
            practices or the content of such sites. Each linked site maintains
            its own independent privacy and data collection policies and
            procedures, and you are encouraged to view the privacy policies of
            these other sites before providing any personal information. You
            hereby acknowledge and agree that Op4Insights is not
            responsible for the privacy practices, data collection policies and
            procedures, or the content of such third-party sites, and you hereby
            release Op4Insights from any and all claims arising out of or
            related to the privacy practices, data collection policies and
            procedures, and/or the content of such third-party sites.
          </p>
        </section>

        <section className="box">
          <h2>14. Children’s Privacy</h2>
          <p>
            The Service is not intended for any individual under the age of 18
            years, or the legal age as prescribed under the relevant law. The
            Op4Insights does not knowingly collect the personal information of
            any individual under the age of 18 years.
          </p>
        </section>

        <section className="box">
          <h2>15. Changes to this Privacy Notice</h2>
          <p>
            The Policy may be revised from time to time. Upon change of the
            terms of the Policy, we will remind you of the changed privacy
            protection guidance upon version update and let you know of the
            effective date.
          </p>
          <p>
            Please read the amended privacy protection guidance in detail, and
            your continued use of the Platform constitutes your consent of our
            processing of your personal information in accordance with the
            updated Privacy Notice. If the processing purpose and processing
            method of personal information, and the type of personal information
            to be processed are changed, we will request for your further
            consent.
          </p>
        </section>

        <section className="box">
          <h2>16. Contact Us</h2>
          <p>
            If you have any questions or comments about this Privacy Notice or
            the Service provided by Op4Insights, please contact us at:
            dataprotectionofficer@Op4Insights.com
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
